import React from "react";

// TODO: Fix SuspenseContent component so it does not "flash"
// i.e. when loading a page with multiple content fetches occuring.
export default text => <p>{text}</p>;
